import { ScheduleSummaryPrioritizedLaunch } from 'src/Components/ScheduleSummary/ScheduleSummaryDetails/ScheduleSummaryStartDateRow'
import { formatDate } from 'src/Constants/formatDate'
import dayJs from 'src/Helpers/dayjs'
import { useHasPlan } from 'src/Hooks/useHasPlan'
import { usePrioritizedLaunchAddOn } from 'src/Hooks/usePrioritizedLaunchAddOn'
import { OrderItem, OrderItemType, OrderStatus } from 'src/Redux/artistOrderApi'
import { isOrderLocked } from 'src/Redux/artistOrderApi/isOrderLocked'
import { useGetSubscriptionQuery } from 'src/Redux/subscription-process/subscriptionApi'

interface UseTikTokPrioritizedLaunchParams {
  campaignId: number
  budget: number
  startDate: string
  orderId?: number
  orderItems?: OrderItem[]
  orderStatus?: OrderStatus
  calculateCurrencyValue: (amount: number | undefined) => string
  onAfterMutation: () => Promise<void>
}

export interface UseTikTokPrioritizedLaunchResult {
  prioritizedLaunch?: ScheduleSummaryPrioritizedLaunch
}

const getIsPrioritizedLaunchEligible = (
  isSubscriptionResolved: boolean,
  hasPlan: boolean,
): boolean => isSubscriptionResolved && !hasPlan

export const useTikTokPrioritizedLaunch = ({
  campaignId,
  budget,
  startDate,
  orderId,
  orderItems,
  orderStatus,
  calculateCurrencyValue,
  onAfterMutation,
}: UseTikTokPrioritizedLaunchParams): UseTikTokPrioritizedLaunchResult => {
  const { isSuccess: isSubscriptionResolved } = useGetSubscriptionQuery()
  const hasPlan = useHasPlan()

  const isEligible = getIsPrioritizedLaunchEligible(
    isSubscriptionResolved,
    hasPlan,
  )

  const { isEnabled, price, onChange } = usePrioritizedLaunchAddOn({
    orderId,
    orderItems,
    campaignId,
    budget,
    isEligible,
    onAfterMutation,
    addOnType: OrderItemType.TiktokPrioritizedLaunch,
    isOrderMutable: !isOrderLocked(orderStatus),
  })

  return {
    prioritizedLaunch:
      isEligible || isEnabled
        ? {
            startDate: dayJs(startDate).format(formatDate.formatDateMonthFull),
            price: `+ ${calculateCurrencyValue(price)}`,
            isEnabled,
            onChange,
          }
        : void 0,
  }
}
